/**
 * Client API pour l'API Origin360 Tracking.
 * Utilise le même token que la session en cours (auth Admin ou unifié).
 */
import axios, { AxiosInstance } from "axios";

const TRACKING_API_BASE_URL =
  process.env.REACT_APP_TRACKING_API_BASE_URL || "";

export function createTrackingClient(accessToken: string | undefined): AxiosInstance {
  const client = axios.create({
    baseURL: TRACKING_API_BASE_URL,
    headers: {
      "Content-Type": "application/json",
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
  });

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        // Token invalide ou expiré - laisser l'app gérer (ex. redirect login)
      }
      return Promise.reject(error);
    }
  );

  return client;
}

export { TRACKING_API_BASE_URL };
